<div class="catalogs-tab d-flex flex-column gap-3">
  <div class="panel_title">
    {{ 'Katalog, der prepriert wird' | translate }}
    <i class="dx-icon-info panel_title__info" #activeInfo></i>
    <dx-tooltip
      [target]="activeInfo"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      position="top"
    >
      <div *dxTemplate="let data of 'content'">
        {{ 'Dieser Katalog wird beim Transfer in die Preparation übernommen. Per Drag & Drop oder Import befüllen.' | translate }}
      </div>
    </dx-tooltip>
  </div>

  <div
    class="upload-zone"
    [class.upload-zone--dragover]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <dx-sortable
      class="drop-zone-sortable"
      [data]="activeCatalogItems"
      group="catalogDragGroup"
      itemOrientation="vertical"
      handle=".catalog-row__drag"
      [allowReordering]="false"
      (onAdd)="onDropAddTop($event)"
    >
      <div *ngFor="let catalog of activeCatalogItems" dxSortableItem style="width: 100%;">
        <div
          class="catalog-row catalog-row--active"
          (click)="onCatalogRowClick(catalog.id)"
          (dblclick)="onCatalogJumpClicked(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
            <div class="catalog-row__subtitle">
              {{ 'Aktiver Katalog' | translate }}
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button icon="export" stylingMode="text" type="default" (onClick)="onCatalogJumpClicked(catalog.id)"></dx-button>
            <dx-button icon="overflow" stylingMode="text" type="default" (onClick)="onCatalogOverflowClicked(catalog.id, $event)"></dx-button>
          </div>
        </div>
      </div>
    </dx-sortable>

    <div *ngIf="activeCatalogItems.length === 0" class="drop-zone-placeholder">
      <i class="dx-icon-upload" style="font-size: 20px; vertical-align: middle;"></i>
      <span style="margin-left: 6px;">{{ 'Hier Daten importieren: Excel, BMECat, FTP …' | translate }}</span>
      <span class="ms-1">{{ 'oder' | translate }}</span>
      <dx-button
        class="ms-1"
        text="{{ 'Datei auswählen' | translate }}"
        stylingMode="text"
        type="default"
        [elementAttr]="{ style: 'font-size: inherit; pointer-events: auto;' }"
        (onClick)="openImportPopupRequested.emit()"
      ></dx-button>
    </div>

    <input #fileInput type="file" multiple class="d-none" (change)="onFileInputChange($event)" />
  </div>

  <div class="comparison-header">
    <div class="panel_title" style="margin: 0;">
      {{ 'Katalog, mit dem verglichen wird' | translate }}
      <i class="dx-icon-info panel_title__info" #compareInfo></i>
      <dx-tooltip
        [target]="compareInfo"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="top"
      >
        <div *dxTemplate="let data of 'content'">
          {{ 'Optionaler Referenzkatalog. „Vergleich starten“ ermittelt neue, geänderte und gelöschte Produkte gegenüber diesem Katalog.' | translate }}
        </div>
      </dx-tooltip>
    </div>
    <div class="d-flex align-items-center gap-2">
      <dx-button
        *ngIf="showCompareExport"
        text="{{ 'Vergleichsexport starten' | translate }}"
        type="default"
        stylingMode="outlined"
        [disabled]="!canStartComparison"
        (onClick)="onStartCompareExport()"
      >
      </dx-button>
      <dx-button
        text="{{ 'Vergleich starten' | translate }}"
        type="default"
        stylingMode="outlined"
        [disabled]="!canStartComparison || isComparing"
        (onClick)="onStartComparison()"
      >
      </dx-button>
    </div>
  </div>

  <app-user-action-window
    *ngIf="showCompareExport"
    #compareExportWindow
    [catalogId]="container?.activeCatalogId"
  ></app-user-action-window>

  <div
    class="upload-zone upload-zone--compare"
    [class.upload-zone--dragover]="isDragOverCompare"
    (dragover)="onDragOverCompare($event)"
    (dragleave)="onDragLeaveCompare()"
    (drop)="onDropCompare($event)"
  >
    <dx-sortable
      class="drop-zone-sortable"
      [data]="compareCatalogItems"
      group="catalogDragGroup"
      itemOrientation="vertical"
      handle=".catalog-row__drag"
      [allowReordering]="false"
      (onAdd)="onDropAddCompare($event)"
    >
      <div *ngFor="let catalog of compareCatalogItems" dxSortableItem style="width: 100%;">
        <div
          class="catalog-row catalog-row--compare"
          (click)="onCatalogRowClick(catalog.id)"
          (dblclick)="onCatalogJumpClicked(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
            <div class="catalog-row__subtitle">
              <span class="badge badge--compare">{{ 'Vergleich' | translate }}</span>
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button icon="export" stylingMode="text" type="default" (onClick)="onCatalogJumpClicked(catalog.id)"></dx-button>
            <dx-button icon="overflow" stylingMode="text" type="default" (onClick)="onCatalogOverflowClicked(catalog.id, $event)"></dx-button>
          </div>
        </div>
      </div>
    </dx-sortable>

    <div *ngIf="compareCatalogItems.length === 0" class="drop-zone-placeholder">
      <span>{{ 'Vergleichskatalog importieren oder ablegen' | translate }}</span>
    </div>

    <input #fileInputCompare type="file" multiple class="d-none" (change)="onFileInputChangeCompare($event)" />
  </div>


  <div *ngIf="!hasCatalogs" class="empty-state">
    {{ 'Und hier entsteht Ihr Katalogimportarchiv!' | translate }}
  </div>
</div>

<div class="panel_archiv">
  <div *ngIf="isArchiveLoading" class="mt-2">
    {{ 'Lade Katalogarchiv …' | translate }}
  </div>

  <div *ngIf="!isArchiveLoading && (!archiveCatalogs || archiveCatalogs.length === 0)" class="mt-2">
    <dx-sortable
      [data]="archiveCatalogs"
      group="catalogDragGroup"
      (onAdd)="onDropAddArchive($event)"
    >
      <div style="min-height: 40px;">
        {{ 'Und hier entsteht Ihr Katalogimportarchiv!' | translate }}
      </div>
    </dx-sortable>
  </div>

  <div *ngIf="!isArchiveLoading && archiveCatalogs?.length" class="mt-2">
    <div class="catalog-list">
      <dx-sortable
        [data]="archiveCatalogs"
        itemOrientation="vertical"
        handle=".catalog-row__drag"
        dragDirection="vertical"
        group="catalogDragGroup"
        (onReorder)="onArchiveReorder($event)"
        (onAdd)="onDropAddArchive($event)"
      >
        <div
          class="catalog-row catalog-row--muted"
          *ngFor="let catalog of archiveCatalogs"
          dxSortableItem
          (click)="onCatalogRowClick(catalog.id)"
          (dblclick)="onCatalogJumpClicked(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button
              icon="overflow"
              stylingMode="text"
              type="default"
              (onClick)="onCatalogOverflowClicked(catalog.id, $event)"
            >
            </dx-button>
          </div>
        </div>
      </dx-sortable>
    </div>
  </div>

    <dx-context-menu
        #catalogContextMenu
        [dataSource]="contextMenuItems"
        showEvent=""
        [width]="200"
        (onItemClick)="itemClick($event)">
        <div *dxTemplate="let e of 'item'">
            <div>
                <span [ngClass]="e.icon"></span>
                <span *ngIf="e.items" class="dx-icon-spinright"></span> {{ e.text }}
                <span *ngIf="e.opensNewTab"  class="glyphicon glyphicon-new-window help-item-icon-right"></span>
            </div>
        </div>
    </dx-context-menu>

    <dx-popup
        class="popup"
        [width]="500"
        [height]="300"
        [showTitle]="true"
        title="Mime importieren"
        [dragEnabled]="true"
        [hideOnOutsideClick]="true"
        [showCloseButton]="true"
        [(visible)]="importMimeVisible"
        (onHiding)="hideImportMime()"
        contentTemplate="popupContent"
    >
        <div *dxTemplate="let data of 'popupContent'">
            <importMime [(isTemplate)]="isTemplate"></importMime>
        </div>
    </dx-popup>


</div>
